"use client"

import { FilterPanel } from "@/components/marketplace/listing/filter-panel"
import type { FacetOption } from "@/components/marketplace/listing/types"
import type { SearchFacet, SearchQuery } from "@/lib/types/search"

interface FilterSidebarProps {
  query: SearchQuery
  categoryOptions?: FacetOption[]
  facets?: SearchFacet[]
  onUpdateQuery: (updates: Partial<SearchQuery>) => void
}

export const FilterSidebar = ({ query, categoryOptions, facets, onUpdateQuery }: FilterSidebarProps) => (
  <aside>
    <FilterPanel query={query} categoryOptions={categoryOptions} facets={facets} onUpdateQuery={onUpdateQuery} />
  </aside>
)
